Vue.component('ack-curo-resins-product-menu', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-curo-resins-product-menu',
    mounted() {
      if (this.menuItems?.length > 0) {
        this.menuItemClick(this.menuItems[0])
      }
    },
    created() {

    },
    props:{
      menuItems: { // :product-info
        type: Array,
        required: true
      },
      isMobile: {
        type: Boolean,
        required: true
      },
      activeItem: {
        type: Object,
        required: true
      }
    },
    computed: {
      //...Vuex.mapGetters('shop', ['productList']),
      ...Vuex.mapGetters('resins', ['activeItem']),
      carouselOptions() {
        let opt = {
          arrows: !this.isMobile,
          dots: false,
          infinite: false,
          slidesToShow: this.isMobile ? 5: 11,
          slidesToScroll: 6,
          autoplay: false,
          speed: 200,
          autoplaySpeed: 0,
          cssEase: 'linear',
          //vertical: this.isMobile ? false : true,
          initialSlide: -1
        }
      
        return opt;
      }
    },
    data() {
      return {
        //activeItem: null
      }
    },
    methods: {
      ...Vuex.mapActions('resins', ['menuItemClick'])
    },
    beforeDestroy() {

    },
    watch: {
      prop1: {
        handler() {


        },
        deep: false
      }
    }
  })